import React from 'react';
import PropTypes from 'prop-types';

import RacingThemeSearchFilterHeader from './RacingThemeSearchFilterHeader';
import RacingThemeSearchFilterGroup from './RacingThemeSearchFilterGroup';
import { SEARCH_FILTER_GROUPS } from '../RacingThemeSearch/searchResultsContent';
import styles from './RacingThemeSearchFilterPanel.module.css';

const filterGroupShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['checkbox', 'price', 'rating']).isRequired,
  schemaType: PropTypes.string,
  options: PropTypes.array,
  minValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

/**
 * Search results filter sidebar.
 */
const RacingThemeSearchFilterPanel = props => {
  const {
    groups = SEARCH_FILTER_GROUPS,
    onClearAll,
    onOptionChange,
    onPriceCommit,
    children,
  } = props;

  return (
    <aside className={styles.filterPanel}>
      <RacingThemeSearchFilterHeader onClearAll={onClearAll} />
      {groups.map(group => (
        <RacingThemeSearchFilterGroup
          key={group.id}
          id={group.id}
          title={group.title}
          type={group.type}
          schemaType={group.schemaType}
          options={group.options}
          minValue={group.minValue}
          maxValue={group.maxValue}
          onOptionChange={onOptionChange}
          onPriceCommit={onPriceCommit}
        />
      ))}
      {children}
    </aside>
  );
};

RacingThemeSearchFilterPanel.propTypes = {
  groups: PropTypes.arrayOf(filterGroupShape),
  onClearAll: PropTypes.func,
  onOptionChange: PropTypes.func,
  onPriceCommit: PropTypes.func,
  children: PropTypes.node,
};

export default RacingThemeSearchFilterPanel;
